import React from 'react';
import { CampaignTabProps } from '../types';
import { LabeledField, TextInput } from '../components/FormControls';
import { ToggleChips } from '../components/ToggleChips';
import { InfoBox } from '../components/InfoBox';

export const CampaignTab = ({
  values,
  onChange,
  campaignOptions,
  loading,
}: CampaignTabProps) => {
  return (
    <div>
      <LabeledField
        label="Campañas asignadas"
        hint="Podés asignar más de una campaña. Las formas de pago se actualizan automáticamente."
      >
        <ToggleChips
          options={campaignOptions}
          selected={values.campaigns}
          onChange={(next) => onChange('campaigns', next)}
          emptyMessage={loading ? 'Cargando campañas...' : 'No hay campañas activas'}
        />
      </LabeledField>

      <LabeledField
        label="Precio PV en campaña"
        hint="Reemplaza al PVP mientras alguna campaña asignada esté activa."
      >
        <TextInput
          type="number"
          value={values.pvCampaignPrice}
          onChange={(value) => onChange('pvCampaignPrice', value)}
          placeholder="0.00"
          style={{ width: 200 }}
        />
      </LabeledField>

      <InfoBox tone="amber">
        A mayor número de prioridad en el ABM de Campañas, mayor precedencia sobre otras campañas
        activas para el mismo producto.
      </InfoBox>
    </div>
  );
};
